import { FilterFields } from 'shared/mui/Filter/FilterFields/FilterFields';

import { usePresetsListFilterFields } from './hooks/usePresetsListFilterFields';

export const PresetsListFilterForm: React.FC = () => {
  const fields = usePresetsListFilterFields({ resetDependentOnChange: true });

  return <FilterFields fields={fields} />;
};
